export default __webpack_public_path__ + "static/media/corn.94e53e31.svg";